<template>
  <v-app id="app-wrapper" :style="$vuetify.breakpoint.xsOnly ? 'overflow: hidden;' : null">
    <app-header />
    <v-main>
      <router-view />
      <snackbarNotifications />
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from './components/AppHeader';
import SnackbarNotifications from './components/SnackbarNotifications';
import ExplorerSidebar from './components/Explorer/ExplorerSidebar';

import { isUser } from '@/store/useAuth';

export default {
  components: {
    AppHeader,
    ExplorerSidebar,
    SnackbarNotifications
  },
  setup() {
    return { isUser };
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
html {
  overflow: hidden;
}
.v-application {
  font-family: 'Catamaran', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

:focus {
  border: none !important;
  outline: none !important;
}

.vuetify {
  text-align: center;
  margin: 16px 0;
  color: #fff;
}

.copy {
  text-align: left;
  padding-left: 1rem;
}

.main > .container {
  padding: 1rem 3rem 0;
}

::-webkit-scrollbar {
  width: 5px;
  padding-top: 25px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: #939393;
  border: 2px solid #8f8f8f;
}
</style>
